export const SOCIAL_PLATFORMS_NAMES = {
  instagram: 'Instagram',
  tiktok: 'TikTok',
  youtube: 'Youtube',
  snapchat: 'Snapchat',
};
